// ** Initial State
const initialState = {
  dropdown: [],
  dropdownFormatted: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedDesignation: null
}

const designations = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DESIGNATIONS_DROPDOWN':
      return { 
        ...state, 
        dropdown: action.data,
        dropdownFormatted: action.data.map(item => ({
          label: item.designation,
          value: item.id,
        }))
      }
    case 'GET_ALL_DESIGNATIONS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_DESIGNATIONS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_DESIGNATION':
      return { ...state, selectedDesignation: action.selectedDesignation }
    case 'ADD_DESIGNATION':
      return { ...state }
    case 'DELETE_DESIGNATION':
      return { ...state }
    default:
      return { ...state }
  }
}
export default designations
